import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { BrokenContainerReportFieldsFragmentDoc } from '../fragments/brokenContainerReport.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClearBrokenContainerMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type ClearBrokenContainerMutation = { __typename?: 'Mutation', clearBrokenContainer: { __typename?: 'BrokenContainerReport', id: string, store_id: string, store_name?: string | null, context: Types.BrokenContainerReportContext, merchant_order_id?: string | null, merchant_order_delivery_note_id?: number | null, comment?: string | null, created_at: string, created_by?: string | null, container_total: number, lines: Array<{ __typename?: 'BrokenContainerLine', id: string, container_type_id: number, container_type_name?: string | null, image_url?: string | null, amount: number, part: Types.BrokenContainerPart, active?: boolean | null, cleared_at?: string | null, cleared_by?: string | null, container?: { __typename?: 'ReturnOrderContainer', id: string, name?: string | null, short_id?: string | null } | null, photos: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url_full_size: string, created_at: string, thumbnail_url: string }> }>, photos: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url_full_size: string, created_at: string, thumbnail_url: string }> } };


export const ClearBrokenContainerDocument = gql`
    mutation ClearBrokenContainer($id: ID!) {
  clearBrokenContainer(id: $id) {
    ...BrokenContainerReportFields
  }
}
    ${BrokenContainerReportFieldsFragmentDoc}`;
export type ClearBrokenContainerMutationFn = Apollo.MutationFunction<ClearBrokenContainerMutation, ClearBrokenContainerMutationVariables>;

/**
 * __useClearBrokenContainerMutation__
 *
 * To run a mutation, you first call `useClearBrokenContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearBrokenContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearBrokenContainerMutation, { data, loading, error }] = useClearBrokenContainerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClearBrokenContainerMutation(baseOptions?: Apollo.MutationHookOptions<ClearBrokenContainerMutation, ClearBrokenContainerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearBrokenContainerMutation, ClearBrokenContainerMutationVariables>(ClearBrokenContainerDocument, options);
      }
export type ClearBrokenContainerMutationHookResult = ReturnType<typeof useClearBrokenContainerMutation>;
export type ClearBrokenContainerMutationResult = Apollo.MutationResult<ClearBrokenContainerMutation>;
export type ClearBrokenContainerMutationOptions = Apollo.BaseMutationOptions<ClearBrokenContainerMutation, ClearBrokenContainerMutationVariables>;